<template>
  <div class="main-search">
    <form style="padding: 0 1.5vw;background:#fff;height: 15vw;" action="/">
      <van-icon name="arrow-left" @click="clickBack" />
      <van-search
        v-model="content"
        placeholder="请输入搜索关键词"
        show-action
        shape="round"
        @search="onSearch"
        class="searchHead"
      >
        <div slot="action">
          <div @click="onSearch(content)">搜索</div>
          <van-icon
            name="apps-o"
            @click="handleClick()"
            v-show="!isShow"
            :class="isGridShow? 'red' :''"
          />
        </div>
      </van-search>
    </form>
    <div class="allSearch" v-show="isShow">
      <div class="hot">
        <p>热门搜索</p>
        <van-tag
          color="#F5F5F5"
          text-color="#333333"
          size="medium"
          v-for="(hotTag,index) in hotList"
          :key="index"
          @click="getClick(hotTag)"
        >
          <span>{{hotTag}}</span>
        </van-tag>
      </div>
      <div class="searchHistory" v-if="tagList.length>0">
        <ul class="textBox">
          <li class="searchHis">搜索历史</li>
          <li class="historyDel">
            <van-icon name="delete" @click="handleDel" :color="isColor? 'red' : ''" />
          </li>

          <van-dialog v-model="isShowTitle" title="标题" show-cancel-button>
            <p>确定要删除么</p>
          </van-dialog>
        </ul>
        <div class="tagDiv">
          <van-tag
            color="#F5F5F5"
            text-color="rgba(51, 51, 51, 1) "
            size="medium"
            v-for="(keyWords,index) in tagList"
            :key="index"
            @click="getfun(keyWords)"
            style="margin:1vw"
          >
            <span class="tagKeywords">{{keyWords}}</span>
          </van-tag>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  Search,
  Tag,
  Icon,
  DropdownMenu,
  DropdownItem,
  Button,
  Grid,
  GridItem,
  Image,
  Toast,
  Dialog
} from "vant";
export default {
  components: {
    [Search.name]: Search,
    [Tag.name]: Tag,
    [Icon.name]: Icon,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Button.name]: Button,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Image.name]: Image,
    [Toast.name]: Toast,
    [Dialog.Component.name]: Dialog.Component
  },
  data() {
    return {
      showEmpty: false,
      content: "卫生",
      tagList: [],
      hotList: ["女", "夜用", "组合", "苏菲", "超薄"],
      show: {
        primary: true,
        success: true
      },
      isShowTitle: false,
      tabData: [],
      active: 0,
      loading: false,
      isShow: true,
      dropDown: {
        drop1: {
          value: 0,
          options: [
            { text: "综合排序", value: 0 },
            { text: "销量排序", value: 1 },
            { text: "价格排序", value: 2 }
          ]
        },
        drop2: {
          value: "a",
          options: [
            { text: "列表展示", value: "a" },
            { text: "格子展示", value: 1 }
          ]
        }
      },
      newsarr: [],
      isGridShow: false,
      isColor: false,
      page: 0,
      pageSize: 0,
      IsSort: 0
    };
  },
  created() {
    let searchLog = JSON.parse(localStorage.getItem("searchLog"));
    this.tagList = searchLog == null ? [] : searchLog;
  },
  methods: {
    onSearch(content) {
      let searchLog = JSON.parse(localStorage.getItem("searchLog"));
      this.$router.push({ path: "/searchList", query: { value: content } });
      if (content !== "") {
        let arr = [];
        arr.push(content);
        if (searchLog !== null) {
          searchLog.map(keyWords => {
            arr.push(keyWords);
          });
          let newArr = Array.from(new Set(arr)).slice(0, 12);
          this.tagList = newArr;
          localStorage.setItem("searchLog", JSON.stringify(newArr));
        } else {
          localStorage.setItem("searchLog", JSON.stringify([content]));
          this.tagList.push(content);
        }
      }
    },
    historyContent(content) {
      let searchLog = JSON.parse(localStorage.getItem("searchLog"));
      if (content !== "") {
        let arr = [];
        arr.push(content);
        if (searchLog !== null) {
          searchLog.map(keyWords => {
            arr.push(keyWords);
          });
          let newArr = Array.from(new Set(arr)).slice(0, 12);
          this.tagList = newArr;
          localStorage.setItem("searchLog", JSON.stringify(newArr));
        } else {
          localStorage.setItem("searchLog", JSON.stringify([content]));
          this.tagList.push(content);
        }
      }
    },

    clickBack() {
      this.$router.go(-1);
    },
    getfun(keyWords) {
      this.content = keyWords;
      this.$router.push({ path: "/searchList", query: { value: keyWords } });
    },
    getClick(hotTag) {
      this.content = hotTag;
      this.historyContent(hotTag);
      this.$router.push({ path: "/searchList", query: { value: hotTag } });
    },

    handCancel() {
      this.$router.push("group");
    },

    handleDel() {
      this.isColor = true;
      setTimeout(() => {
        localStorage.removeItem("searchLog");
        Toast.success("删除成功");
        location.reload();
      }, 500);
    },
    onConfirm() {
      this.$refs.items.toggle();
    }
  }
};
</script>
<style lang="less" scoped>
// .main-search {
//   width: 100%;
//   height: 100%;
//   .van-icon-arrow-left {
//     font-size: 6vw;
//     margin-top: 3.9vw;
//     float: left;
//   }
//   .red {
//     color: red;
//   }
//   .searchHead {
//     width: 90vw;
//     float: left;
//     .van-search__action {
//       line-height: 0;
//       .van-icon {
//         font-size: 5.33333vw;
//       }
//     }
//   }
//   .allSearch {
//     margin: 0 4vw;
//     .hot {
//       height: 35vw;
//       p {
//         font-size: 4vw;
//         color: rgba(157, 157, 157, 1);
//       }
//       .van-tag--default {
//         margin: 1vw;
//         span {
//           margin: 1.3vw 3.5vw;
//           font-weight: 600;
//         }
//       }
//     }
//     .searchHistory {
//       width: 100%;
//       height: 35vw;
//       margin-top: 4vw;
//       color: rgba(157, 157, 157, 1);
//       .textBox {
//         width: 100%;
//         .searchHis {
//           font-size: 4vw;
//           float: left;
//         }
//         .historyDel {
//           margin-left: 68vw;
//           margin-top: 3vw;
//           float: left;

//           .van-icon-delete {
//             font-size: 4.6vw;
//           }
//         }
//       }
//       .tagDiv {
//         width: 100%;
//         .tagKeywords {
//           margin: 1.3vw 3.5vw;
//           font-weight: bold;
//         }
//       }
//     }
//   }
// }
.search {
  &-head {
    width: 100vw;
  }
}
</style>